import { Injectable } from '@angular/core';
import { AlertControllerService } from '../alert-controller/alert-controller.service';
import { localStorageKeys } from '../../Constants/local-storage-keys';
import { ICustomClipboardService } from './custom-clipboard.service.interface';

@Injectable()
export class CustomClipboardService implements ICustomClipboardService {

  private externalClipboardText: string = '';
  private internalClipboardText: string = '';

  constructor() {
    this.setInternalText();
    this.setExternalText();
  }

  public getCopiedText(): string {
    return this.internalClipboardText;
  }

  public saveCopiedText(text: string): void {
    this.saveInternalText(text);
  }

  public updateClipboards(externalClipboardText: string) {
    if (this.externalClipboardText !== externalClipboardText) {
      this.saveExternalText(externalClipboardText);
      this.saveInternalText(externalClipboardText);
    }
  }

  public async fetchFromSystemClipboard() {
    navigator.clipboard.readText()
      .then(text => {
        this.saveExternalText(text);
      })
      .catch(err => {
        console.log('External text not saved: ', err);
      })
  }

  private setExternalText() {
    this.externalClipboardText = localStorage.getItem(localStorageKeys.EXTERNAL_CLIPBOARD_TEXT);
  }

  private saveExternalText(text: string) {
    localStorage.setItem(localStorageKeys.EXTERNAL_CLIPBOARD_TEXT, text);
    this.setExternalText();
  }

  private setInternalText() {
    this.internalClipboardText = localStorage.getItem(localStorageKeys.INTERNAL_CLIPBOARD_TEXT);
  }

  private saveInternalText(text: string) {
    localStorage.setItem(localStorageKeys.INTERNAL_CLIPBOARD_TEXT, text);
    this.setInternalText();
  }
}
